import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { Button, InputNumber, Space } from "antd";
import { useRef, useState } from "react";
import K from "utilities/constants";
import { dollarformatter } from "utilities/tableUtility";
import { CandidateFieldLabel } from "../candidateFieldLabel/candidateFieldLabel";
import { CandidateFieldValue } from "../candidateFieldValue/candidateFieldValue";

export const CandidateSalaryField = ({
  label,
  value,
  isEditable = false,
  disabled = false,
  onEdit,
}) => {
  const [isEdit, setIsEdit] = useState(false);
  const inputRef = useRef(value);

  const handleSave = () => {
    if (inputRef.current !== value) onEdit?.(inputRef.current);
    setIsEdit(false);
  };

  const handleCancel = () => {
    inputRef.current = value;
    setIsEdit(false);
  };

  if (isEdit) {
    return (
      <div>
        <CandidateFieldLabel>{label}</CandidateFieldLabel>
        <InputNumber
          defaultValue={value}
          min={0}
          style={{ width: "100%" }}
          formatter={dollarformatter}
          parser={(val) => val.replace(/\$\s?|(,*)/g, "")}
          onChange={(val) => {
            inputRef.current = val;
          }}
        />
        <div style={{ marginTop: 4 }}>
          <Button
            type="link"
            onClick={handleCancel}
            icon={<CloseCircleOutlined className="closeIcon" />}
          />
          <Button
            type="link"
            onClick={handleSave}
            icon={<CheckCircleOutlined className="checkIcon" />}
          />
        </div>
      </div>
    );
  }

  return (
    <div>
      <CandidateFieldLabel>{label}</CandidateFieldLabel>
      <Space size={4} style={{ minHeight: 24 }}>
        <CandidateFieldValue>
          {value != null ? dollarformatter(value) : K.NullPlaceholder}
        </CandidateFieldValue>
        {isEditable && !disabled && (
          <Button
            style={{ width: 16, height: 16 }}
            type="link"
            onClick={() => {
              inputRef.current = value;
              setIsEdit(true);
            }}
            icon={<i className="icon-edit" />}
          />
        )}
      </Space>
    </div>
  );
};
